import { IconFileTrash16 } from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import { MenuItem } from '../../../components/SavedSearches/MobileComponents/MenuItem';

export interface IDeleteActionContainerProps {
  onClick(): void;
}

export const DeleteActionContainer: React.FC<IDeleteActionContainerProps> = ({ onClick }) => {
  return (
    <MenuItem
      icon={<IconFileTrash16 color="icon-negative-default" />}
      label="Удалить"
      color="text-negative-default"
      onClick={onClick}
    />
  );
};
